import { cva } from 'class-variance-authority';

export const container = cva([
  'flex',
  'w-full',
  'h-full',
  'flex-col',
  'p-2',
  'mb-12',
  'sm:mb-0',
  'sm:h-[calc(100vh-11rem)]',
  'h-[calc(100vh-17rem)]',
]);

export const content = cva(['flex', 'w-full', 'h-full', 'flex', 'gap-4']);

export const main = cva([
  'w-full overflow-y-auto',
  'flex flex-col gap-4 pr-2 pb-2',
]);

export const slot = cva([
  'w-full rounded-2xl data-[swapy-highlighted]:bg-neutral-100',
]);
